module.exports = __webpack_public_path__ + "static/media/error-icon.a67f38d6.svg";